const getDuration = (file: Blob): Promise<number> => {
  return new Promise((resolve, reject) => {
    const blobUrl = URL.createObjectURL(file);
    const audio = new Audio();
    audio.preload = "metadata";
    audio.src = blobUrl;
    audio.muted = true;

    audio.onerror = (): void => {
      URL.revokeObjectURL(blobUrl);
      reject(new Error("Error al cargar los metadatos del audio."));
    };

    audio.onloadedmetadata = (): void => {
      if (audio.duration === Infinity || isNaN(audio.duration)) {
        audio.currentTime = Number.MAX_SAFE_INTEGER;
        audio.ontimeupdate = (): void => {
          audio.ontimeupdate = null;
          const actualDuration = audio.duration;
          audio.currentTime = 0;
          URL.revokeObjectURL(blobUrl);
          resolve(actualDuration);
        };
      } else {
        const duration = audio.duration;
        URL.revokeObjectURL(blobUrl);
        resolve(duration);
      }
    };
  });
};

export default getDuration;
